<template>
    <div id="event-creator" class="dialog event-dialog" style="display:none">
        <div id="store-event-creator" class="dialog__container">
            <div class="dialog__container--title">建立優惠</div>

            <form id="event-form" method="post" :action="this.url" style="padding: 10px">
                <div class="event-form-section">
                    <div class="title">類別</div>
                    <div id="type-opts" class="mdc-select" data-mdc-auto-init="MDCSelect">
                        <i class="mdc-select__dropdown-icon"/>
                        <select id="type-opts-selector" class="mdc-select__native-control" name="type" required v-on:change.prevent="typeChanged">
                            <option value="" selected/>
                            <option v-for="type in types" :value="type.key">{{ type.name }}</option>
                        </select>
                        <label for="type-opts-selector" class="mdc-floating-label">優惠類別</label>
                        <div class="mdc-line-ripple"></div>
                    </div>
                </div>

                <div class="event-form-section">
                    <div class="title">折扣</div>
                    <div class="event-tf mdc-text-field">
                        <i class="material-icons mdc-text-field__icon"/>
                        <input type="number" id="discount" name="discount" class="mdc-text-field__input" min=".1" max="9.9" step=".1" value="8.5" required>
                        <label for="discount" class="mdc-floating-label">可獲得折扣「85折, 請輸入8.5」</label>
                        <div class="mdc-line-ripple"></div>
                    </div>
                </div>

                <div class="title">生效條件</div>
                <store-event-from :except="false" :type="this.type"/>

                <button id="btn-except" type="button" class="mdc-button" v-on:click.prevent="addExcept">
                    <span class="mdc-button__icon material-icons">add_circle</span>
                    <span class="mdc-button__label">點擊設定排除條件</span>
                </button>

                <div ref="exceptions"></div>
            </form>

            <div class="dialog__container--action">
                <button type="button" class="mdc-button" onclick="$('.dialog.event-dialog').hide()">
                    <span class="mdc-button__label">取消</span>
                </button>
                <button type="button" class="mdc-button mdc-button--raised" v-on:click.prevent="submit">
                    <span class="mdc-button__label">儲存</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import StoreEventFrom from "./store-event-from";
    import Vue from 'vue';
    export default {
        components: {StoreEventFrom},
        props: {
            'url': {
                type: location | String,
                required: true,
            }
        },
        data: function() {
            return {
                except: false,
                index: 0,
                type: null,
                types: [
                    {
                        key: 'date',
                        name: '日期',
                    },
                    {
                        key: 'weekdays',
                        name: '星期',
                    },
                    {
                        key: 'time',
                        name: '時段',
                    },
                    {
                        key: 'person',
                        name: '人數',
                    },
                ]
            }
        },
        computed: {
        },
        methods: {
            typeChanged(event) {
                this.type = event.target.value;
                this.$nextTick(function () {
                    window.mdc.autoInit();
                });

                while (this.$refs.exceptions.lastChild) {
                    this.$refs.exceptions.removeChild(this.$refs.exceptions.lastChild);
                }
            },
            addExcept(event) {
                let ComponentClass = Vue.extend(StoreEventFrom);
                let instance = new ComponentClass({
                    propsData: {
                        except: true,
                        index: this.index++,
                        type: this.type,
                    }
                });
                instance.$mount();

                this.except = true;

                this.$refs.exceptions.appendChild(instance.$el);
            },
            submit(event) {
                let form = $('#event-form');
                let data = new FormData(form[0]);
                let url = form.attr('action');

                if (this.except) {
                    data.set('except', '1');
                }

                data.removeEmptyAttrs();

                popsale.formRequest(url, 'post', data, function () {
                    popsale.snackText("修改成功");
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                });
            },
        },
        mounted() {
            this.$nextTick(function () {
                window.mdc.autoInit();
            }.bind(this));
        }
    }
</script>

<style lang="scss">
    #store-event-creator.dialog__container {
        overflow-y: auto;
    }

    #event-form {
        .event-form-section {
            .mdc-text-field, .mdc-select {
                &:last-child {
                    margin-bottom: 10px;
                }
            }

            .title {
                display: block;
                font-size: 1.1em;
                font-weight: 500;
                margin: 0 5px 5px 5px;
            }
        }
    }

    .event-tf, .type-selector {
        border-radius: 0;
    }

    .event-tf {
        width: 100%;
        flex-basis: 100%;
    }

    #type-opts.mdc-select {
        width: 100%;
        border-radius: 0;
    }
</style>